"use strict";

exports.__esModule = true;
exports.default = void 0;

var _reactGa = _interopRequireDefault(require("react-ga"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackForm = function trackForm(category) {
  return function (e) {
    var _ref = e.target || e,
        type = _ref.type,
        checked = _ref.checked,
        value = _ref.value,
        name = _ref.name;

    var getAttribute = function getAttribute(attr) {
      return e.target && e.target.getAttribute(attr);
    };

    var isPassword = type === 'password';
    var trackValue = getAttribute('data-track-value') === 'on' ? value : undefined;
    var label = getAttribute('data-track-label') || trackValue;
    var action = getAttribute('data-track-action') || name;

    if (type === 'checkbox') {
      action += checked ? ' on' : ' off';
    } // will be turned on when all react forms are updated
    // if (!action || action === 'null') {
    // 	return;
    // }


    if (isPassword || !label) {
      return _reactGa.default.event({
        category: category,
        action: action
      });
    }

    _reactGa.default.event({
      category: category,
      action: action,
      label: label
    });
  };
};

var _default = trackForm;
exports.default = _default;